module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_nato-35bdb16e382e1297fb1440ee932194d1.png";